const map = state => state.map;
const lastReadMessages = state => state.lastReadMessages;
const unreadCount = state => state.unreadCount;

export default {
  map,
  lastReadMessages,
  unreadCount,
};
